<template>
  <div v-on:click="isPlaying && displayedSequence && openDetail()" class="m-viewer">
    <canvas ref="canvas" class="scene"></canvas>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import * as THREE from 'three';
import Resize from 'parcel-rxjs-threejs-pack/src/app/core/Resize';
import Sequence3D from '@/scene/Sequence3D';
import Detail3D from '../../scene/Detail3D';

const DEPTH = 8;
const D = DEPTH * 1.8;

const camera = new THREE.PerspectiveCamera(80, window.innerWidth / window.innerHeight, 0.1, D);
camera.position.z = D - 2;

const scene = new THREE.Scene();

let renderer;

let sequences3D = [
  new Sequence3D(),
  new Sequence3D(),
  new Sequence3D(),
];

function render() {
  requestAnimationFrame(render);

  for (let i = 0, l = scene.children.length; i < l; i += 1) {
    const child = scene.children[i];
    child.animate();
    if (child instanceof Sequence3D) {
      child.position.z = DEPTH * child.animation.movement;
    }
  }
  renderer.render(scene, camera);
}

export default {
  name: 'viewer',
  data() {
    return {
      unsubcribers: [],
      timer: setTimeout(() => {}),
    };
  },
  computed: {
    ...mapGetters([
      'loading',
      'isPlaying',
      'sequences',
      'currentSequence',
      'displayedSequence',
      'nextSequence',
      'isDetail',
    ]),
  },
  mounted() {
    renderer = new THREE.WebGLRenderer({
      canvas: this.$refs.canvas,
      antialias: true,
    });
    renderer.setClearColor(0xffffff);
    renderer.setPixelRatio(window.devicePixelRatio || 1);

    this.resize();
    this.detail3D = new Detail3D();
    this.detail3D.position.z = D - 2.59;
    this.unsubcribers = [
      Resize.debounceTime(150).subscribe(() => this.resize()),
    ];

    sequences3D.forEach(f => scene.add(f));
    scene.add(this.detail3D);
    requestAnimationFrame(render);
  },
  methods: {
    ...mapMutations([
      'play',
      'pause',
      'openDetail',
      'closeDetail',
    ]),
    ...mapActions([
      'playNextSequence',
    ]),
    resize() {
      const WIDTH = window.innerWidth;
      const HEIGHT = window.innerHeight;

      this.$refs.canvas.width = WIDTH;
      this.$refs.canvas.height = HEIGHT;

      camera.aspect = WIDTH / HEIGHT;
      camera.updateProjectionMatrix();

      renderer.setSize(WIDTH, HEIGHT);
    },
  },
  watch: {
    isDetail(isDetail) {
      if (isDetail) {
        this.detail3D.show();
        sequences3D.forEach(s => s.stopAnimation());
        /* if (this.currentSequence === this.displayedSequence) {
          sequences3D.forEach(s => s.stopAnimation());
        } else {
          sequences3D[0].stopAnimation();
          sequences3D[1].pauseAnimation(0);
        } */
      } else {
        this.detail3D.hide();
      }
    },
    isPlaying(isPlaying) {
      sequences3D.forEach(s => (isPlaying ? s.playAnimation() : s.pauseAnimation()));
    },
    loading(isLoading) {
      if (isLoading) sequences3D.forEach(s => s.stopAnimation());
    },
    displayedSequence(newDisplayedSequence) {
      const next = sequences3D[0];
      next.endAnimation();
      this.detail3D.setSequence(newDisplayedSequence);
    },
    currentSequence(newCurrentSequence) {
      const next = sequences3D[0];
      const current = sequences3D[1];

      next.setSequence(newCurrentSequence)
        .then(() => next.startAnimation());

      sequences3D = [
        current,
        next,
      ];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .m-viewer {
    position: relative;
    cursor: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Player/Viewer.vue